import styled from "styled-components";

export const Icons = styled.svg`
  fill: ${({ theme }) => theme.colors.colorSix};
  color: ${({ theme }) => theme.colors.colorSix};
  margin-right: 0.5rem;
`;
